import customSelect from 'custom-select';
import GLightbox from 'glightbox';
import LazyLoad from 'vanilla-lazyload';
import {gsap, Power1} from 'gsap';

/* eslint-disable*/
/* eslint-disable no-debugger, no-console */
export default {
  init(albumType = null) {
    const regionField = document.getElementById('filter-region'),
      editionField = document.getElementById('filter-edition-year'),
      departmentField = document.getElementById('filter-department'),
      presetEdition = document.getElementById('last_edition'),
      btnReinitialize = document.getElementById('btn-filter-reset'),
      overlayLoader = document.getElementById('overlay-loader'),
      btnLoadMore = document.getElementById('btn-load-more'),
      albumsLoader = document.getElementById('albums-loader'),
      formAlbumsFilter = document.getElementById('albums-filters'),
      albumsGridArea = document.getElementById('more-albums'),
      btnApplyFilter = formAlbumsFilter.querySelector('.filter__btn-apply'),
      albumFooter = document.querySelector('.albums-footer'),
      paramsAjax = ['current_page', 'album_edition', 'album_region', 'album_department'];

    let defaultRegions = null,
      defaultDepartments = null,
      defaultEditions = null,
      regionCusSelect = null,
      editionCusSelect = null,
      depCusSelect = null,
      lightbox = null,
      isLoadingAlbumGallery = false;

    let lazyLoadInstance;

    if (departmentField) {
      // Keep the default department list options
      defaultDepartments = {...departmentField.options};
    }

    if (regionField) {
      // Keep the default region list options
      defaultRegions = {...regionField.options};
    }

    if (editionField) {
      // Keep the default edition list options
      defaultEditions = {...editionField.options};
    }

    /**
     * reset default params
     */
    const resetDefaultParams = () => {
      window.album_loadmore_params.album_department = '';
      window.album_loadmore_params.album_region = '';
      window.album_loadmore_params.album_edition = '';
      window.album_loadmore_params.current_page = 1;

      if (albumType !== '' && albumType === 'previous') {
        window.album_loadmore_params.editions = 'previous';
      }
    }

    /**
     * Re-intialize all the fields with default values
     */
    const reInitAllFields = () => {
      if (depCusSelect !== null) {
        resetAllSelectOptions(depCusSelect, defaultDepartments);
      }
      if (editionCusSelect !== null) {
	      //editionCusSelect.value = `${albumType}`;
        editionCusSelect.value = 'default'
      }
      regionCusSelect.value = 'default';
    }

    /**
     * Initialize event listeners
     */
    const initListeners = () => {
      if (regionField) {
        regionField.addEventListener('change', function (event, value) {
          handleRegionChange(event, value)
        });
      }

      if (departmentField) {
        departmentField.addEventListener('change', (event, value) => handleDepartmentChange(event, value));
      }

      if (editionField) {
        editionField.addEventListener('change', (event, value) => handleEditionChange(event, value));
      }

      if (btnReinitialize) {
        btnReinitialize.addEventListener('click', (e) => {
          e.preventDefault()
          reInitAllFields();
          resetDefaultParams();
        });
      }

      if (btnLoadMore) {
        btnLoadMore.addEventListener('click', (e) => {
          e.preventDefault();
          loadAlbums();
          return false;
        });
        btnLoadMore.click();
      }

      if (btnApplyFilter) {
        btnApplyFilter.addEventListener('click', (e) => {
          e.preventDefault();
          updateParamsUrl();
          cleanAlbum();
        })
      }
    }

    const handleAlbumClick = () => {
      let albums = document.querySelectorAll('.album__link-area');
      albums.forEach((album) => {
        let albumID = album.dataset.album;
        album.addEventListener('click', (e) => {
          e.preventDefault();
          if (!isLoadingAlbumGallery) {
            loadAlbumGallery(albumID);
          }
        });
      })
    }

    const loadAlbumGallery = (album) => {
      if (!album || album === '') {
        return
      }
      $.ajax({
        url: window.album_loadmore_params.ajax_url, // AJAX handler
        data: {
          'action': 'loadalbumgallery',
          'album_id': album,
        },
        type: 'POST',
        beforeSend: function (xhr) {
          isLoadingAlbumGallery = true;
          if (overlayLoader !== null) {
            gsap.set(overlayLoader, {display: "flex"});
            gsap.to(overlayLoader, {opacity: 1, duration: 0.5, ease: Power1.easeOut});
          }
        },
        error: function (err) {
          console.log(err)
        },
        success: function (posts) {
          if (posts) {
            //let areaAlbumsLatestEdition = document.getElementById('albums-latest-edition');
            let areaAlbumsLatestEdition = document.getElementById('section-albums');
            let e = document.createElement('div');
            e.classList.add('row');

            let galleryImages = JSON.parse(posts);
            let gallerySlides = [];

            if (galleryImages instanceof Array) {
              galleryImages[0].album_gallery.forEach((post) => {
                gallerySlides.push({
                  'href': post['sizes']['large'],
                  'type': 'image',
                  'title': post['title'],
                  'description': `
                    ${galleryImages[0]['region'][0]['name']} - ${galleryImages[0]['department'][0]['name']}
                    <p class="media__share">Partager <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fffve-jnve.fr%2Fderniere-edition" class="media-share-fb"><i class="icon icon-facebook"></i></a></p>
                  `,
                })
              })
            }

            areaAlbumsLatestEdition.appendChild(e);
            initLightbox(gallerySlides);
            isLoadingAlbumGallery = false;
          } else {
            // gsap.to(albumFooter, {opacity: 0, duration: 0.75, ease: Power1.easeIn});
          }
        },
      });
    }

    /**
     * updateParamsUrl
     */
    const updateParamsUrl = () => {
      let args = [];

      paramsAjax.map((param) => {
        let ajaxParam = window.album_loadmore_params[param];
        if (typeof ajaxParam !== 'undefined' && ajaxParam !== '' && ajaxParam !== 'previous' && ajaxParam !== 'latest') {
          if (param === 'current_page') {
            ajaxParam = ajaxParam - 1;
          }
          args.push(`${param}=${ajaxParam}`);
        }
      });

      if (args.length !== 0) {
        let params = args.join('&');
        let baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
        let refresh;

        if (!baseUrl.includes('?')) {
          refresh = baseUrl + '?' + params;
        } else {
          refresh = baseUrl + params;
        }

        window.history.pushState({path: refresh}, '', refresh);
      }
    }

    /**
     * cleanAlbum
     */
    const cleanAlbum = () => {
      albumsGridArea.innerHTML = '';
      resetFormPost();
      loadAlbums();
    }

    /**
     * resetFormPost
     */
    const resetFormPost = () => {
      window.album_loadmore_params.current_page = 1;
    }

    /**
     * Handle region's select field changes
     * @param event
     */
    const handleRegionChange = (event) => {
      let currentVal = event.target.value;
      window.album_loadmore_params.album_region = event.target.value === "default" ? '' : event.target.value;
      window.album_loadmore_params.album_department = '';
      filterDepartment(currentVal);
      updateParamsUrl();
    }

    /**
     * Filter department's select field based on region param
     * @param regionID
     */
    const filterDepartment = (regionID) => {
      if (!departmentField) {
        return;
      }
      if (regionID !== 'default') {
        resetAllSelectOptions(depCusSelect, defaultDepartments, removeOptions, [depCusSelect, parseInt(regionID)]);
      } else {
        resetAllSelectOptions(depCusSelect, defaultDepartments);
      }
    }

    /**
     * Handle department select field changes
     * @param event
     */
    const handleDepartmentChange = (event) => {
      window.album_loadmore_params.album_department = event.target.value === "default" ? '' : event.target.value;
      updateParamsUrl();
    }

    /**
     * Handle edition select field changes
     * @param event
     */
    const handleEditionChange = (event) => {
      window.album_loadmore_params.album_edition = event.target.value === "default" ? '' : event.target.value;
      updateParamsUrl();
    }

    /**
     *
     Method to reset default options of specific field
     * @param select
     * @param defaultValues
     * @param callback
     * @param callbackParam
     */
    const resetAllSelectOptions = (select, defaultValues, callback = false, callbackParam) => {
      if (select) {
        select.empty();

        Promise.all(Object.values(defaultValues).map((option) => {
          select.append(option);
          return true;
        }))
          .then(() => {
            select.value = 'default'
          });
      }

      if (callback) {
        // Force first item (default) to be selected
        callback(...callbackParam);
      }
    }

    /**
     * Remove select options base on regionID
     * @param select
     * @param dataAttr
     */
    const removeOptions = (select, dataAttr) => {
      for (let i = select.select.length - 1; i >= 1; i--) {
        parseInt(select.select.options[i].dataset.region) !== dataAttr && select.remove(select.select.options[i]);
      }
    }

    /**
     * Customize all select fields
     * @param callback
     */
    const customAllSelect = (callback = false) => {

      const listAllSelectName = ['filter-region', 'filter-department', 'filter-edition-year'];

      listAllSelectName.map(item => customSelect(`#${item}`, {
          openerClass: 'btn btn-secondary dropdown-toggle',
          panelClass: 'select-panel',
          optionClass: 'dropdown-item',
        })
      )

      if (departmentField) {
        depCusSelect = departmentField.customSelect;
        if (albumType !== 'latest') {
          depCusSelect.disabled = true;
        }
      }

      if (regionField) {
        regionCusSelect = regionField.customSelect;
      }

      if (editionField) {
        editionCusSelect = editionField.customSelect;
      }

      if (callback) {
        callback();
      }
    }

    /**
     * check query url
     */
    const checkQueryUrl = () => {
      let queryAlbumRegion = getParameterByName('album_region');
      let queryAlbumDepartment = albumType === 'latest' ? getParameterByName('album_department') : false;
      let queryAlbumEdition = getParameterByName('album_edition');

      let args = [
        {
          'param': queryAlbumRegion,
          'field': regionField,
        },
        {
          'param': queryAlbumDepartment,
          'field': departmentField,
        },
        {
          'param': queryAlbumEdition,
          'field': editionField,
        },
      ];

      args.map(el => {
        if (el.param) {
          for (let i = el.field.length - 1; i >= 1; i--) {
            if (el.field.getElementsByTagName('option')[i].value === el.param) {
              el.field.getElementsByTagName('option')[i].selected = 'selected';
            }
          }
        }
      });
    }

    /**
     *
     * @param name
     * @param url
     * @returns {string|null}
     */
    const getParameterByName = (name, url = window.location.href) => {
      name = name.replace(/[\]]/g, '\\$&');
      let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    /**
     * Load albums
     */
    const loadAlbums = () => {
      if (btnLoadMore) {
        const defaultButtonText = btnLoadMore.innerHTML;
        gsap.to(albumFooter, {opacity: 1, duration: 1, ease: Power1.easeOut});

        $.ajax({
          url: window.album_loadmore_params.ajax_url, // AJAX handler
          data: {
            'action': 'loadmoremedias', // the parameter for admin-ajax.php
            'query': window.album_loadmore_params.posts, // loop parameters passed by wp_localize_script()
            'current_page': window.album_loadmore_params.current_page, // current page
            'editions': window.album_loadmore_params.editions,
            'album_edition': presetEdition.value ? presetEdition.value : window.album_loadmore_params.album_edition,
            'album_region': window.album_loadmore_params.album_region,
            'album_department': window.album_loadmore_params.album_department
          },
          type: 'POST',
          beforeSend: function (xhr) {
            gsap.to(albumFooter, {opacity: 0, duration: 0.5, ease: Power1.easeOut});
            btnLoadMore.innerText = 'Chargement ...';
            albumsLoader.classList.remove('d-none');
            albumsLoader.classList.add('d-flex');
          },
          error: function (err) {
            console.log(err)
          },
          success: function (posts) {
            btnLoadMore.innerHTML = defaultButtonText;
            albumsLoader.classList.remove('d-flex');
            albumsLoader.classList.add('d-none');

            if (posts) {
              if (posts === 'finished') {
                gsap.to(albumFooter, {opacity: 0, duration: 1, ease: Power1.easeOut});
                return;
              }

              window.album_loadmore_params.current_page++;
              updateParamsUrl();

              let areaMoreAlbums = document.getElementById('more-albums');
              let e = document.createElement('div');
              e.classList.add('row')
              e.innerHTML = posts;
              areaMoreAlbums.appendChild(e);

              // Update lazy loading
              lazyLoadInstance.update();

              if (lightbox != null) {
                lightbox.reload();
              }

              gsap.to(albumFooter, {opacity: 1, duration: 0.75, ease: Power1.easeIn, delay: 1});

            } else {
              gsap.to(albumFooter, {opacity: 0, duration: 0.75, ease: Power1.easeIn});
            }

            handleAlbumClick();
          },
        });
      }
    }

    /**
     * Album's lightbox
     */
    const initLightbox = (elements) => {
      let headerContent;
      let urlLogo = '/app/uploads/2021/08/logo-ffve-blue-@2x.png';

      const previousEdition = `<div class="header__title">
        Les Éditions précédentes des JEP
      </div>`;

      const headerLastEdition = `<div class="header__logo">
        <div class="brand__logo">
          <img width="122" height="96" src="${urlLogo}" class="custom-logo" alt="Logo FFVE">
        </div>
        <div class="brand__name">
          <span>JEP</span> <span>2023</span>
        </div>
      </div>`;

      //headerContent = document.body.classList.contains('template-latest-edition') ? headerLastEdition : previousEdition;
	headerContent = headerLastEdition

      const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container ${albumType === 'latest' && 'glightbox--latest'}">
        <div class="gloader visible"></div>
        <div class="goverlay"></div>
        <div class="gcontainer">
          <div class="glightbox-header">
            <div class="slide-counter">
                <span class="slide__current"></span>/<span class="slide__total"></span>
            </div>
            ${headerContent}
            <div class="msg-rotate"><i class="icon icon-ico-rotate"></i> Pour une meilleure visibilité tournez votre téléphone</div>
          </div>
          <div id="glightbox-slider" class="gslider">
          </div>
          <div class="gslide-nav-desktop">
            <button class="gnext gbtn d-none d-lg-flex" tabindex="0" aria-label="Suivant"><i class="icon icon-ico-arrow-left"></i></button>
            <button class="gprev gbtn d-none d-lg-flex" tabindex="1" aria-label="Précédent"><i class="icon icon-ico-arrow-left"></i></button>
          </div>
          <button class="gclose gbtn" tabindex="2" aria-label="Fermer"><i class="icon icon-ico-close"></i></button>
        </div>
       </div>`;

      let customSlideHTML = `<div class="gslide">
          <div class="gslide-inner-content">
              <div class="ginner-container">
                  <div class="gslide-media">
                  </div>
                  <div class="gslide-description">
                      <div class="gslide-nav-mobile d-flex d-lg-none">
                        <button class="gprev clone gbtn d-flex" tabindex="1" aria-label="Précédent"><i class="icon icon-ico-arrow-left"></i></button>
                        <button class="gnext clone gbtn d-flex" tabindex="0" aria-label="Suivant"><i class="icon icon-ico-arrow-left"></i></button>
                      </div>
                      <div class="gdesc-inner">
                          <h4 class="gslide-title"></h4>
                          <div class="gslide-desc">
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>`;

      lightbox = GLightbox({
        elements: elements,
        openEffect: 'fade',
        closeEffect: 'fade',
        draggable: true,
        zoomable: false,
        touchFollowAxis: false,
        moreLength: 0,
        lightboxHTML: customLightboxHTML,
        slideHTML: customSlideHTML,
        // skin: 'supercool',
        touchNavigation: true,
        loop: false,
        autoplayVideos: false,
      });

      lightbox.on('open', () => {
        let slidesTotal = document.querySelector('.slide__total');
        let slider = document.getElementById('glightbox-slider');
        let count = slider.childNodes.length - 1;
        slidesTotal.innerHTML = count;

        if (overlayLoader !== null) {
          gsap.to(overlayLoader, {opacity: 0, duration: 0.5, ease: Power1.easeOut});
          gsap.set(overlayLoader, {display: "none"});
        }

        // Config share facebook
        let btnShareFacebook = document.querySelector('.media-share-fb');

        btnShareFacebook.addEventListener('click', (e) => {
          e.preventDefault();
          sharefbimage();
        })
      });

      lightbox.on('close', () => {
        lightbox.destroy();
      });

      lightbox.on('slide_changed', ({current}) => {
        // Adjust counter current slide
        let slideCurrent = document.querySelector('.slide__current');
        slideCurrent.innerHTML = current.slideIndex + 1;

        // Config mobile arrow navigation
        let gprevDefault = document.querySelector('.gslide-nav-desktop .gprev');
        let gnextDefault = document.querySelector('.gslide-nav-desktop .gnext');
        let gprevMobile = document.querySelector('.gslide.current .gslide-nav-mobile .gprev');
        let gnextMobile = document.querySelector('.gslide.current .gslide-nav-mobile .gnext');

        gprevMobile.addEventListener('click', () => {
          // Trigger main default item click
          gprevDefault.click();
        });

        gnextMobile.addEventListener('click', () => {
          // Trigger main default item click
          gnextDefault.click();
        })
      });

      lightbox.open();
    }

    /**
     * share facebook dialog
     */
    const sharefbimage = () => {
      let img = document.querySelector('.gslide.current img');

      FB.init({
        appId: `868377564097846`,
        status: true,
        cookie: true,
        xfbml: true,
        version: 'v2.9',
        display: 'popup'
      });
      
      FB.ui({
        method: 'share_open_graph',
        action_type: 'og.shares',
        action_properties: JSON.stringify({
          object: {
            'og:url': window.location.href, // your url to share
            'og:title': 'My Title',
            'og:description': 'My Description',
            'og:image': 'http://ww.mywebpage.com/myimage.gif',
            'og:image:type': 'image/gif',
            'og:image:width': '1200',
            'og:image:height': '630'
          }
        })
      },
        function (response) {
          if (response && response.post_id) {
            console.log('success');
          } else {
            console.log('error');
          }
        }
      );
    }

    /**
     * Lazy Loading images
     */
    const initLazy = () => {
      let callback_loaded = function (element) {
        element.classList.remove('is-loading');
      };
      let callback_error = function (element) {
        element.src =
          'https://via.placeholder.com/440x560/?text=Error+Placeholder';
      };

      lazyLoadInstance = new LazyLoad({
        callback_loaded: callback_loaded,
        callback_error: callback_error,
      });
      lazyLoadInstance.update();
    }

    /**
     * Init calls
     */

    checkQueryUrl();
    customAllSelect(initListeners);
    initLazy();
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/components/album.js